import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ff6d2d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hpb-title" }, "Check the places", -1 /* HOISTED */))
const _hoisted_2 = { class: "nge-hpb-pos" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-hpb-how" }, "The cell as players will see it. Go to each place and look: take out any that is not a real merger or extension, or add a point in the Mergers or Extensions layer.", -1 /* HOISTED */))
const _hoisted_4 = { class: "nge-hpb-steps" }
const _hoisted_5 = { class: "nge-hpb-list" }
const _hoisted_6 = { class: "nge-hpb-check" }
const _hoisted_7 = ["checked"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.session && $setup.fromEdits.history)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "boxEl",
        class: _normalizeClass(["nge-hpb", { 'nge-hpb--dragging': $setup.dragging }]),
        style: _normalizeStyle($setup.boxStyle),
        role: "dialog",
        "aria-label": "Check the Hunt's places"
      }, [
        _createElementVNode("div", {
          class: "nge-hpb-head",
          title: "Drag to move",
          onPointerdown: _cache[0] || (_cache[0] = (...args) => ($setup.startDrag && $setup.startDrag(...args)))
        }, [
          _hoisted_1,
          _createElementVNode("span", _hoisted_2, "Before " + _toDisplayString($setup.day($setup.session.at)), 1 /* TEXT */)
        ], 32 /* HYDRATE_EVENTS */),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "nge-hpb-btn",
            onClick: _cache[1] || (_cache[1] = $event => ($setup.stepPlace(-1)))
          }, "Previous"),
          _createElementVNode("button", {
            class: "nge-hpb-btn",
            onClick: _cache[2] || (_cache[2] = $event => ($setup.stepPlace(1)))
          }, "Next place")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode($setup["HuntPlacesList"])
        ]),
        _createElementVNode("label", _hoisted_6, [
          _createElementVNode("input", {
            type: "checkbox",
            checked: $setup.fromEdits.finished,
            onChange: $setup.finished
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_7),
          _createTextVNode(" Show the finished cell (only you see it)")
        ]),
        _createElementVNode("button", {
          class: "nge-hpb-btn nge-hpb-btn--back",
          onClick: $setup.back
        }, "Back to the Hunt editor")
      ], 6 /* CLASS, STYLE */))
    : _createCommentVNode("v-if", true)
}